export const INTERNATIONAL_SIZES_ORDER = [
    'XXXS',
    'XXS',
    '2XS',
    'XS',
    'S',
    'M',
    'L',
    'XL',
    '2XL',
    'XXL',
    '3XL',
    'XXXL',
    '4XL',
    '5XL',
    '6XL',
    '7XL',
    '8XL',
    '9XL',
    '10XL',
    '11XL',
    '12XL',
];
export const CLOTHING_CHILDREN_AGE = [
    '0-6m',
    '6-12m',
    '12-18m',
    '18-24m',
    '2-3yrs',
    '3-4yrs',
    '4-5yrs',
    '5-6yrs',
    '7-9yrs',
    '9-11yrs',
    '10-12yrs',
    '12-14yrs',
    '14-16yrs',
];
export const CUSTOMISATION_POSITIONS = [
    'Left Breast',
    'Right Breast',
    'Centre of Chest',
    'Left Sleeve',
    'Right Sleeve',
    'Big Front',
    'Big Back',
    'Nape of Neck',
];
export const COLOUR_SHADE = [
    'Aqua Blue',
    'Light Blue',
    'Mid Blue',
    'Royal Blue',
    'Charcoal',
    'Heather Grey',
    'Light Grey',
    'Silver Grey',
    'Bottle Green',
    'Kelly Green',
    'Lime',
    'Olive',
    'Khaki',
    'Natural',
    'Bright Red',
    'Classic Red',
    'Chocolate',
    'Cognac',
    'Mid Brown',
    'Bright Yellow',
    'Gold',
    'Light Yellow',
    'Fuchsia',
    'Hot Pink',
    'Light Pink',
    'Light Purple',
    'Peach',
];
